import { PageSort } from "@modules/main/model/dto/sort/PageSort";

export class PrioritySort extends PageSort {

    public property: string = "priority";

    public direction: string = "ASC";
}